let base_api_prefix = process.env.VUE_APP_BASE_API_PREFIX
let root_url = base_api_prefix +'ccicnb-main-provider'
let auth_url = base_api_prefix+'ccicnb-auth-provider'
/*
let root_url = 'https://ccicnb-zjlm-dev.cnoolbest.com/ccicnb-main-provider'
let auth_url = 'https://ccicnb-zjlm-dev.cnoolbest.com/ccicnb-auth-provider'
if (process.env.NODE_ENV == 'production') {
    root_url = 'https://zjlmapi.ccicnb.com.cn/ccicnb-main-provider'
    auth_url = 'https://zjlmapi.ccicnb.com.cn/ccicnb-auth-provider'
} */
export default {
    upload: root_url + '/file/upload',//文件上传
    getImgCode: auth_url + '/login/getImgCode',//获取验证码
    sendV2: auth_url + '/login/smsValidateCode/sendMobile',//获取短信验证码（登录）
    sendSms: auth_url + '/login/SmsValidateCode/sendV2',//获取短信验证码
    loginByPassword: root_url + '/customer/login/mobile',//密码登录
    loginBySms: root_url + '/customer/login/sms',//短信登录
    updatePwdByMobile:root_url + '/customer/login/updatePwdByMobile',//忘记密码
    userRegistration: auth_url + '/member/userRegistration',//注册第一步
    userRegistrationSave: root_url + '/customer-info/userRegistrationSave',//注册第二步
    salesRegistration: auth_url + '/member/salesRegistration',//加入我们
    customerLoginSave: root_url + '/api/customer-consult/customerLoginSave',//已登录联系我们
    customerNotLoginSave: root_url + '/api/customer-consult/customerNotLoginSave',//未登录联系我们
    getUserInfo:auth_url + '/member/getInfo',//联系我们内容
    notLoginList:root_url + '/industry/notLoginList',//行业列表
    getCertificationInformation: root_url + '/customer-account/getCertificationInformation',//认证信息
    unbind: root_url + '/customer-account',//解绑
    changeInformation: root_url + '/customer-info/changeInformation',//变更证件
    getCorporatememberList: root_url + '/customer-account/getCorporatememberList',//企业人员
    getMemberList: auth_url + '/member/customerList',//账号列表
    setPermissions: root_url + '/customer-account/setPermissions',//设置权限
    changeAccount: root_url + '/customer-account',//切换认证
    removeEnterpriseMembers: root_url + '/customer-account/removeEnterpriseMembers',//移除人员
    transferSuperpipes: root_url + '/customer-account/transferSuperpipes',//转让超管
    addEnterpriseMembers: root_url + '/customer-account/addEnterpriseMembers',//添加企业人员
    orderInfoPage: root_url + '/um/order-info/page',//分页列表
    orderInfoCancel: root_url + '/um/order-info/cancel',//取消订单
    orderInfoGetCustomerQuotation: root_url + '/um/order-info/getCustomerQuotation',//查询报价单
    orderInfoAgree: root_url + '/um/order-info/agree',//同意报价单
    orderInfoGetContractAttachmentUrls: root_url + '/um/order-info/getContractAttachmentUrls',//获取合同附件
    orderInfoGetEntrustList: root_url + '/um/order-info/getEntrustList',//进度跟踪
    orderInfoGetEntrustDetail: root_url + '/um/order-info/getEntrustDetail',//委托单服务项
    orderInfoGetUnConfirmedEntrustList: root_url + '/um/order-info/getUnConfirmedEntrustList',//查询所有待确认证稿的委托单
    orderInfoConfirm: root_url + '/um/order-info/confirm',//确认证稿（旧接口）
    orderInfoConfirmDraft: root_url + '/um/order-info/confirmDraft',//确认证稿（新接口，支持按证稿索引确认）
    changePassword: auth_url + '/member/updatePwd',//修改密码
    submitOrderComment: root_url + '/um/order-comment/submitOrderComment',//提交订单评价
    getOrderComment: root_url + '/um/order-comment/getOrderComment',//获取订单评价
}